module.exports = __webpack_public_path__ + "img/2.b199eb09.png";